import { observable, action } from 'mobx';

export interface IError {
    reason: {
        message: string;
    };
}

export class ErrorBoundaryStore {
    @observable public hasError: boolean = false;
    @observable public isModalOpen: boolean = false;
    @observable public isSystemUnavailable: boolean = false;

    @action
    public openModal() {
        this.isModalOpen = true;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public onError() {
        this.hasError = true;
    }

    @action
    public onFetchError(error: IError) {
        const errorCode = Number(error.reason.message);
        if ((errorCode >= 400 && errorCode < 500) || isNaN(errorCode)) {
            this.isModalOpen = true;
        }
        if (errorCode >= 500) {
            this.isSystemUnavailable = true;
        }
    }
}
